export type AccessCodeDto = {
  id?: number;
  respondentId?: number;
  respondentConnectedId?: number;
  respondentEmail?: string;
  code: string;
  subscribed: boolean;
  surveyLink: string;
  projectDistribution: string;
};

export type AccessCodeModel = {
  respondentId: number;
  respondentConnectedId: number;
  respondentEmail: string;
  distribution: string;
  code: string;
  surveyLink: string;
  subscribed: boolean;
};

export function mapAccessCodeModelToDto(model: AccessCodeModel): AccessCodeDto {
  return {
    projectDistribution: model.distribution,
    surveyLink: model.surveyLink,
    code: model.code,
    subscribed: model.subscribed,
  };
}

export function mapAccessCodeDtoToModel(dto: AccessCodeDto): AccessCodeModel {
  return {
    respondentId: dto.respondentId,
    respondentConnectedId: dto.respondentConnectedId,
    respondentEmail: dto.respondentEmail,
    surveyLink: dto.surveyLink,
    code: dto.code,
    subscribed: dto.subscribed,
    distribution: dto.projectDistribution,
  };
}
